import { Subject } from 'rxjs/Subject';
import { Injectable } from '@angular/core';
import { ICharge, ICredit } from '../../../../core/interfaces/billing.interface';

@Injectable()
export class ComunicationEditBilling {
  public tripid: number;
  public riderid: number;
  public credit: boolean;
  public creditsByTrip: ICredit[];
  public chargesByTrip: ICharge[];
  public upDateBilling = new Subject();
  public getUpDate = this.upDateBilling.asObservable();
  public openCreate = new Subject<boolean>();
  public getOpenCreate = this.openCreate.asObservable();
  public notification = new Subject<any>();
  public received = this.notification.asObservable();
  constructor() {}
}




// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/edit-reservation/edit-billing/comunication-edit-billing.ts